import baseApi from './base';
import { HelperTag, FaqTag } from './tags';
import { HelperType, FaqType } from '../types/helper';

const helperApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getHelperContent: build.query<HelperType[], string>({
      query: () => `elearning-help-contents`,
      providesTags: [HelperTag],
    }),
    getHelperFaq: build.query<FaqType[], string>({
      query: () => `faqs`,
      providesTags: [FaqTag],
    }),
  }),
  overrideExisting: false,
});

export const { useGetHelperContentQuery, useGetHelperFaqQuery } = helperApi;

export default helperApi;
